import api from '../../config/APIConfig';

const { iAxios, apiUri } = api;
const baseUrl = `${apiUri}/Khipu`;

export const KiphuActions = {
    GeneraPago
    ,ConfirmarPago
}
function GeneraPago(Token) {
  return iAxios.get(`${baseUrl}?Token=`+Token,{headers: {'sitePath': document.URL}})
}
function ConfirmarPago(Token) {
  return iAxios.get(`${baseUrl}/ConfirmarPago?Token=`+Token)
}


